import React, { useContext, useState, useEffect } from 'react';
import { Button, Typography, Grid, Container, Divider, List, ListItem, ListItemText, Box, Card, CardContent, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import format from 'date-fns/format';
import DeleteIcon from '@mui/icons-material/Delete';
import { eliminarItemCarrito, confirmarReserva, obtenerMuestroCarrito, obtenerDatosHotel, graboReservaEnAdmintour, obtenerReservasMotor, obtenerDetalleCarrito } from '../../services/motorService';
import RoomTypeRatePlanContext from '../contexts/RoomTypeRatePlanContext';
import useSession from '../../services/session';
import PersonalData from '../personalData/PersonalData';
import Cookies from 'js-cookie';
import Payment from '../payment/Payment';
import { Stepper, Step, StepLabel, StepContent, Paper } from '@mui/material';
import jsPDF from 'jspdf';
import {obtenerImagenCabezal} from '../../services/motorService';
import DownloadPDF from '../downloadPDF/DowloadPDF';
import { ContactSupportOutlined } from '@mui/icons-material';
const Checkout = () => {
    const { cartItems, setCartItems, setReservaAdmintour, reservaAdmintour } = useContext(RoomTypeRatePlanContext);
    const [setSelectedNav] = useState('checkout');
    const session = useSession();
    const [datosHotel, setDatosHotel] = useState({});
    const [detalleCarrito, setDetalleCarrito] = useState({});
    const [tarjetaEnGarantia, setTarjetaEnGarantia] = useState(null); // Guardar el valor de "tarjeta en garantía"
    const [loading, setLoading] = useState(true); // Manejar el estado de carga
    const [nroReservaAdmintour, setNroReservaAdmintour] = useState('');
    const [nroReservaMotor, setNroReservaMotor] = useState('');
    const [rateDetail, setRateDetail] = useState(null);
    const navigate = useNavigate(); // Hook para la navegación
    const hotCod = Cookies.get('hotCod');
    const [bannerUrl, setBannerUrl] = useState(null);
    const [formValues, setFormValues] = useState({
        motorreservanombretitular: '',
        motorreservaapellidotitular: '',
        reservanombre: '',
        reservatipodocumento: "",
        reservadocumento: "",
        reservatelefono: '',
        correoElectronico: '',
        reservadireccion: '',
        reservafechanacimiento: null, 
        reservapais: '',
        reservaobservaciones: '',
        reservaautocolor: '',
        reservaautomarca: '',
        reservaautomatricula: '',
    });
    const [isChecked, setIsChecked] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);  // Estado para manejar el diálogo

    const steps = [
        { label: 'Datos Personales', component: <PersonalData formValues={formValues} setFormValues={setFormValues} setIsFormValid={setIsFormValid} /> },
        { label: 'Método de Pago', component: <Payment/> },
        { label: 'Reserva Finalizada', component: <Typography variant="body1">Selecciona el botón para completar tu reserva</Typography> },
      ];
      const [activeStep, setActiveStep] = useState(0);

      const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      };
    
      const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };
    
      const handleReset = () => {
        setActiveStep(0);
      };

      useEffect(() => {
        const fetchBannerImage = async () => {
            try {
              const imagenBase64 = await obtenerImagenCabezal(hotCod);
              if(!imagenBase64.startsWith('Imagen del Cabezal Sin Datos para el hotel')){
                  setBannerUrl(`data:image/png;base64,${imagenBase64}`);
              }
            } catch (error) {
              console.error('Error fetching header image:', error);
            }
          };
      
          fetchBannerImage();

        const fullName = `${formValues.motorreservanombretitular} ${formValues.motorreservaapellidotitular}`.trim();
    
        // Solo actualiza el nombre completo si ha cambiado
        if (formValues.reservanombre !== fullName) {
            setFormValues((prevValues) => ({
                ...prevValues,
                reservanombre: fullName,
            }));
        }

        const getData = async () => {
            try {
                const data = await obtenerDatosHotel(hotCod); // Usa hotCod en la llamada a la API
                setDatosHotel(data);
                setTarjetaEnGarantia(data.MotorHotSolTarjeta); // Actualiza el estado con el valor de "tarjeta en garantía"
                setLoading(false); // Deshabilita el estado de carga
            } catch (error) {
                console.error('Error fetching hotel data:', error);
            }
        };
        getData();
    
        const isValid =
            formValues.motorreservanombretitular.trim() &&
            formValues.motorreservaapellidotitular.trim() &&
            formValues.reservanombre.trim() &&
            formValues.reservatipodocumento &&
            formValues.reservadocumento.trim() &&
            formValues.reservatelefono.trim() &&
            formValues.correoElectronico.trim() &&
            formValues.reservadireccion.trim() &&
            formValues.reservafechanacimiento &&
            formValues.reservapais;
    
        setIsFormValid(isValid);
    }, [
        formValues.motorreservanombretitular, 
        formValues.motorreservaapellidotitular, 
        formValues.reservanombre, 
        formValues.reservatipodocumento, 
        formValues.reservadocumento, 
        formValues.reservatelefono, 
        formValues.correoElectronico, 
        formValues.reservadireccion, 
        formValues.reservafechanacimiento, 
        formValues.reservapais
    ]);
    

    const handleNavClick = (title) => {
        setSelectedNav(title);
    };

    const handleConfirm = async () => {
        try {
            const reserva = await confirmarReserva(hotCod, session, formValues.reservanombre, formValues.motorreservanombretitular, formValues.motorreservaapellidotitular, formValues.reservatelefono, formValues.correoElectronico, formValues.reservadireccion, formValues.reservatelefono, formValues.reservapais, formValues.reservatipodocumento, formValues.reservadocumento, formValues.reservafechanacimiento, formValues.reservaautocolor, formValues.reservaautomarca, formValues.reservaautomatricula, formValues.reservaobservaciones);
            console.log("RESERVA GRABADA EN EL MOTOR:", reserva);
            const reservaMotorCod = reserva.nroReserva;
            console.log(reservaMotorCod);
            if(datosHotel.MotorUsaChannel === "N"){
                const reservaDelMotor = await obtenerReservasMotor(hotCod, reservaMotorCod);
                console.log("OBTENGO RESERVA DEL MOTOR:", reservaDelMotor);
                const stdMotorReserva = reservaDelMotor.SDT_MotorReserva;                
                const codigoEnAdmintour = datosHotel.MotorHotAdmintour;
                console.log("Codigo en Admintour", codigoEnAdmintour);
                const reservaAdmintour = await graboReservaEnAdmintour(codigoEnAdmintour, reservaMotorCod, stdMotorReserva);
                console.log("RESERVA GRABADA EN ADMINTOUR:", reservaAdmintour);
                const nro = reservaAdmintour.textoreserva.split(":")[1].trim();
                console.log("Nro reserva:", nro);
                setReservaAdmintour(nro);
            }
            navigate(`/MotorReservasAdmintour/resumenReserva`);
        } catch (error) {
            console.error('Error al confirmar la reserva:', error);
        }
    };

    const handleDeleteItem = async (lineNumber) => {
        try {
            await eliminarItemCarrito(hotCod, session, lineNumber);
            const updatedCart = await obtenerMuestroCarrito(hotCod, session); // Actualizar el carrito después de eliminar el ítem
            setCartItems(updatedCart);

            // Si el carrito está vacío, abrir el diálogo de confirmación
            if (!updatedCart) {
                setOpenDialog(true);
            }
        } catch (error) {
            console.error('Error al eliminar el ítem del carrito:', error);
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        navigate(`/MotorReservasAdmintour/disponibilidad`); // Cambia '/disponibilidad' por la ruta adecuada en tu aplicación
    };

    const totalImporte = cartItems
        ? cartItems.reduce((total, item) => total + parseFloat(item.CarritoItemTotal || 0), 0)
        : 0;

    const formatToCustomDate = (date) => {
        const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        return format(utcDate, 'dd/MM/yyyy');
    };

    const formatTitleDate = () => {
        if (cartItems && cartItems.length > 0) {
            const checkinDate = new Date(cartItems[0].CarritoItemDesde);
            const checkoutDate = new Date(cartItems[0].CarritoItemHasta);

            const checkinDay = checkinDate.getUTCDate();
            const checkinMonth = checkinDate.getUTCMonth() + 1;
            const checkinYear = checkinDate.getUTCFullYear();
            const fullcheckinData = checkinDay + "/" + checkinMonth + "/" + checkinYear;

            const checkoutDay = checkoutDate.getUTCDate();
            const checkoutMonth = checkoutDate.getUTCMonth() + 1;
            const checkoutYear = checkoutDate.getUTCFullYear();
            const fullcheckoutData = checkoutDay + "/" + checkoutMonth + "/" + checkoutYear;

            return fullcheckinData + " - " + fullcheckoutData;
        }
        return "";
    };

    const obtengoCarritoMoneda = (carrito) => {
        if (carrito && carrito.length > 0) {
            return carrito[0].CarritoItemMoneda;
        }
        return "";
    };

   /* const detalleDelCarrito = async (cod, ses, i) => {
        try {
            const data = await obtenerDetalleCarrito(cod, ses, i);
            setDetalleCarrito(data);
            console.log("DATA:", data);
            console.log("DETLLE CARRITO;", detalleCarrito);
        } catch (error) {
            console.error('Error fetching carrito data:', error);
        }
    };
    const handleChartDetail = async (lineNumber) => {
        try {
          const detail = await obtenerDetalleCarrito(hotCod, session, lineNumber);
          setRateDetail(detail);
          console.log("Detalle de lo del carrito checkout", detail);
        } catch (error) {
          console.error('Error al obtener el detalle del carrito:', error);
        }
      };
*/


    return (
        <Container sx={{ mt: 5 }}>
                        <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                    <Stepper activeStep={activeStep} orientation="vertical">
                        {steps.map((step, index) => (
                            <Step key={step.label}>
                                <StepLabel>{step.label}</StepLabel>
                                <StepContent>
                                    {step.component}
                                    <Box sx={{ mb: 2 }}>
                                        <div>
                                            {activeStep === steps.length - 1 ? (
                                                <>
                                                <Button onClick={handleBack} sx={{ ml: 1 }}>
                                                                    Atrás
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    onClick={() => {
                                                        handleConfirm(); 
                                                    }}
                                                >
                                                 Confirmar reserva
                                             </Button>
                                             </>
                                            ) : (
                                                <>
                                                    {index === 1 ? (
                                                        tarjetaEnGarantia === "S" ? (
                                                            <>
                                                                <Button onClick={handleBack} sx={{ ml: 1 }}>
                                                                    Atrás
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    onClick={handleNext}
                                                                >
                                                                    Realizar Pago
                                                                </Button>
                                                                
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Button onClick={handleBack} sx={{ ml: 1 }}>
                                                                    Atrás
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    onClick={handleNext}
                                                                >
                                                                    Siguiente
                                                                </Button>
                                                                
                                                            </>
                                                        )
                                                    ) : (
                                                        <>
                                                            <Button
                                                                disabled={index === 0}
                                                                onClick={handleBack}
                                                                sx={{ ml: 1 }}
                                                            >
                                                                Atrás
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                onClick={handleNext}
                                                                disabled={index === 0 && !isFormValid}
                                                            >
                                                                Siguiente
                                                            </Button>
                                                            
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </Box>
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                    {activeStep === steps.length && (
                        <Paper square elevation={0} sx={{ p: 3 }}>
                            <Typography>Todos los pasos completados - ¡La reserva está lista!</Typography>
                        </Paper>
                    )}
                </Grid>
            
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Typography gutterBottom variant="h6" component="div">
                                Detalles del carrito {datosHotel.MotorUsaChannel}
                            </Typography>
                            {cartItems && cartItems.length > 0 ? (
                                <>
                                    <Typography variant="body2" color="textSecondary">
                                        {formatTitleDate()} {`/ ${Math.round((new Date(cartItems[0].CarritoItemHasta) - new Date(cartItems[0].CarritoItemDesde)) / (1000 * 60 * 60 * 24))} noche(s)`}
                                    </Typography>
                                    <Divider />
                                    <List>
                                        {cartItems.map((item, index) => (
                                            <div key={item.CarritoItemLinea}>
                                                <ListItem alignItems="flex-start">
                                                    <ListItemText
                                                        primary={
                                                            <>
                                                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                                    {item.CarritoItemTipoHab}
                                                                </Typography>
                                                                <Typography variant="body1">
                                                                    {item.CarritoItemTarifa}
                                                                </Typography>
                                                            </>
                                                        }
                                                        secondary={
                                                            <>
                                                                <Typography component="div" color="textSecondary" sx={{ marginTop: 2 }}>
                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                        <Typography variant="body2" color="textSecondary">
                                                                            {`${item.CarritoItemMayores} adulto(s), ${item.CarritoItemMenores} menor(es)`}
                                                                        </Typography>
                                                                        <Typography variant="body2" color="textSecondary">
                                                                            {`${item.CarritoItemTotal} ${item.CarritoItemMoneda}`}
                                                                        </Typography>
                                                                    </Box>
                                                                </Typography>
                                                            </>
                                                        }
                                                    />
                                                    <IconButton edge="end" color="inherit" onClick={() => handleDeleteItem(item.CarritoItemLinea)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </ListItem>
                                                {index < cartItems.length - 1 && <Divider />}
                                            </div>
                                        ))}
                                        <Divider />
                                        <Typography component="div" sx={{ marginTop: 2 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                    Total
                                                </Typography>
                                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                    {totalImporte.toFixed(2)} {obtengoCarritoMoneda(cartItems)}
                                                </Typography>
                                            </Box>
                                        </Typography>
                                    </List>
                                </>
                            ) : (
                                <Typography variant="subtitle1" color="text.secondary">
                                    No hay elementos en el carrito.
                                </Typography>
                            )}
                        </CardContent>
                        <CardContent>
                            <Box display="flex" justifyContent="center" sx={{ marginBottom: 2 }}>
                                <Button
                                    variant='outlined'
                                    color='secondary'
                                    onClick={() => navigate(`/MotorReservasAdmintour/disponibilidad`)}
                                    sx={{ width: '100%' }}
                                >
                                    Seguir comprando
                                </Button>
                            </Box>

                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
            >
                <DialogTitle>Carrito Vacío</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        No hay más elementos en el carrito. Serás redirigido a la página de disponibilidad.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default Checkout;